import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";
import { useLoop } from "./arena";

const GROUND = 80;
const OBST = ["🪨", "🥥", "🚧", "🪺"];

// Rolling Tyre: keep the tyre rolling and jump over obstacles. An endless runner — go the distance!
export default function RollingTyre() {
  const [phase, setPhase] = useState("ready");
  const [distv, setDistv] = useState(0);
  const [best, setBest] = useState(0);
  const [, setTick] = useState(0);
  const y = useRef(GROUND);
  const vy = useRef(0);
  const obs = useRef([]);
  const spawn = useRef(0);
  const speed = useRef(46);
  const roll = useRef(0);

  const start = () => { y.current = GROUND; vy.current = 0; obs.current = []; spawn.current = 0; speed.current = 46; roll.current = 0; setDistv(0); setPhase("play"); };
  const jump = () => { if (phase === "play" && y.current >= GROUND - 0.5) { vy.current = -145; sfx.click?.(); } };

  useLoop(phase === "play", (dt) => {
    vy.current += 330 * dt;
    y.current = Math.min(GROUND, y.current + vy.current * dt);
    if (y.current >= GROUND) vy.current = 0;
    roll.current = (roll.current + speed.current * dt * 6) % 360;
    speed.current = Math.min(92, speed.current + 2 * dt);
    obs.current.forEach((o) => { o.x -= speed.current * dt; });
    obs.current = obs.current.filter((o) => o.x > -8);
    spawn.current -= dt;
    if (spawn.current <= 0) { spawn.current = Math.max(0.7, 1.7 - speed.current / 100) * (0.7 + Math.random()); obs.current.push({ x: 105, e: OBST[Math.floor(Math.random() * OBST.length)], id: Math.random() }); }
    // collision (tyre at x~18)
    for (const o of obs.current) { if (o.x > 12 && o.x < 24 && y.current > 66) { setPhase("over"); setBest((b) => Math.max(b, Math.round(dRef.current))); return; } }
    setDistv((d) => { dRef.current = d + speed.current * dt * 0.1; return dRef.current; });
    setTick((x) => (x + 1) % 1e6);
  });
  const dRef = useRef(0);

  useEffect(() => {
    const onKey = (e) => { if (e.code === "Space" || e.key === "ArrowUp") { e.preventDefault(); jump(); } };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Distance" value={`${Math.round(distv)}m`} />
        <AScore label="Best" value={`${best}m`} />
      </div>
      <p className="my-2 text-sm text-kirana-brown/70">Tap / Space / ↑ to jump over obstacles. Don't let the tyre trip!</p>
      <div data-testid="rt-arena" onClick={jump} className="relative mx-auto mb-3 h-56 w-full max-w-md cursor-pointer overflow-hidden rounded-md border-2 border-kirana-border bg-gradient-to-b from-[#bfe3ff] to-[#eaf6ff]">
        <div className="absolute inset-x-0 bg-[#caa472]" style={{ top: `${GROUND + 4}%`, bottom: 0 }} />
        <div className="absolute inset-x-0 h-1 bg-[#8a6a3f]" style={{ top: `${GROUND + 4}%` }} />
        {/* tyre */}
        <div className="absolute" style={{ left: "18%", top: `${y.current}%`, transform: "translate(-50%,-100%)" }}>
          <div className="flex h-9 w-9 items-center justify-center rounded-full border-4 border-[#2b2b2b] bg-[#444] text-[10px] text-white" style={{ transform: `rotate(${roll.current}deg)` }}>✚</div>
        </div>
        {obs.current.map((o) => (
          <div key={o.id} className="absolute text-2xl" style={{ left: `${o.x}%`, top: `${GROUND}%`, transform: "translate(-50%,-100%)" }}>{o.e}</div>
        ))}
        {phase === "ready" && <div className="absolute inset-0 flex items-center justify-center font-signboard text-lg text-kirana-brown/70">Peeche peeche… bhaago!</div>}
      </div>
      <div className="mt-3 flex justify-center gap-3">
        {phase === "ready" && <ABtn data-testid="rt-start" onClick={start} tone="gold" className="px-8 py-3">Start Running</ABtn>}
        {phase === "play" && <ABtn data-testid="rt-jump" onClick={jump} tone="red" className="px-12 py-4 text-lg">JUMP! ⬆️</ABtn>}
        {phase === "over" && (<div className="w-full"><AResult testId="rt-result" win={distv >= 60} text={`${Math.round(distv)}m rolled!${distv >= 60 ? " Shabaash! 🏆" : ""}`} /><div className="mt-3 flex justify-center"><ABtn data-testid="rt-again" onClick={start} tone="green">Play Again</ABtn></div></div>)}
      </div>
    </div>
  );
}
